import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { CartData } from '@Types/Cart';

interface Params {
  signal?: AbortSignal;
}

async function removeCertificate({ signal }: Params = {}) {
  const url = '/cabinet/cart/remove-certificate';
  const res = await Api.queryProxi<{ data: CartData }>(url, {
    signal,
    method: 'POST',
  });

  if (!res.data) throw new BackendError(url, res);

  return res.data;
}

export default removeCertificate;
